import { Locale } from '@repo/common';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { getPublicAsset } from './utils';

export const defaultNS = 'loc';
export const fallbackNS = defaultNS;

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    defaultNS,
    fallbackNS,
    fallbackLng: Locale.EN,
    supportedLngs: Object.values(Locale),
    ns: ['loc'],
    nsSeparator: ':',
    keySeparator: '.',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: getPublicAsset('/locales/{{lng}}/{{ns}}.json'),
    },
  });

export default i18n;
